<template>
  <div class="text-center">
    <i class="far fa-check-circle customCheck"></i>
    <h2 class="p-2 font-weight-bold">¡Se ha creado correctamente!</h2>
    <p
      class="px-4"
    >Aute officia eiusmod Lorem eiusmod sint duis laborum do non. Fugiat Lorem ad irure enim dolore aute magna qui enim qui do fugiat aute ex. Eiusmod et officia excepteur est.</p>
    <router-link to="/login/client" class="font-weight-bold back">Ingresar</router-link>
  </div>
</template>

<script>
export default {
  name: 'Correct'
}
</script>

<style>
.customCheck {
  color: rgb(76, 175, 80);
  font-size: 120px;
}
.back {
  font-size: 25px;
  color: rgb(76, 175, 80);
}
</style>



// WEBPACK FOOTER //
// Correct.vue?75ccbaf8